import { defineStore } from 'pinia';

export const useIsErrorStore = defineStore('isError', {
  state: () => ({
    isError: false,
  }),
  actions: {
    reset() {
      this.isError = false;
    },
  },
});
